<dx-box width="100%" height="100%" direction="col">
    <dxi-item [ratio]="1" align="center" class="vertical-center">
        <h2 class="cc-text-required">Missing / Unaccessible Widget</h2>
    </dxi-item>
</dx-box>
